import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Light weight, not solid: solid faMobile is a filled slab while solid
// faDesktop is mostly outline, and the mismatch reads as uneven spacing.
import { faMobile } from '@fortawesome/pro-light-svg-icons/faMobile';
import { faDesktop } from '@fortawesome/pro-light-svg-icons/faDesktop';
import { TypedMemo } from '../../../common/types';
import { PreviewDevice } from './previewDevice';
import styles from './SMLDeviceToggle.module.scss';

interface SMLDeviceToggleProps {
  device: PreviewDevice;
  onChange: (device: PreviewDevice) => void;
}

const SMLDeviceToggleComponent: React.FC<SMLDeviceToggleProps> = ({ device, onChange }) => {
  const intl = useIntl();
  const selectMobile = useCallback(() => onChange('mobile'), [onChange]);
  const selectDesktop = useCallback(() => onChange('desktop'), [onChange]);

  return (
    <div className={styles.group}>
      <button
        type="button"
        className={clsx(styles.option, device === 'mobile' && styles.selected)}
        onClick={selectMobile}
        aria-pressed={device === 'mobile'}
        aria-label={intl.formatMessage({ id: 'app.sml.smartlinks.preview.mobile', defaultMessage: 'Mobile preview' })}
      >
        <FontAwesomeIcon icon={faMobile} fixedWidth />
      </button>
      <button
        type="button"
        className={clsx(styles.option, device === 'desktop' && styles.selected)}
        onClick={selectDesktop}
        aria-pressed={device === 'desktop'}
        aria-label={intl.formatMessage({ id: 'app.sml.smartlinks.preview.desktop', defaultMessage: 'Desktop preview' })}
      >
        <FontAwesomeIcon icon={faDesktop} fixedWidth />
      </button>
    </div>
  );
};

export const SMLDeviceToggle = TypedMemo(SMLDeviceToggleComponent);
